<template>
  <div class="ch-component-warpper">
    <div class="ch-component">
      <button
        class="ch-floating-btn ch-menu-btn"
        @click="openDialog"
      >
        <span><i class="far fa-plus-square fa-fw"></i></span>
        STAFF
      </button>
      <v-container fluid grid-list-lg class="ch-menu-wrapper">
        <div class="ch-menu-title">
          <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
            <span class="ch-menu-btn-icon" v-show="navigationDrawer">
              <i class="fas fa-minus fa-fw"></i>
            </span>
            <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
              <i class="fas fa-plus fa-fw"></i>
            </span>
          </button> -->
          <span class="ch-component-title pl-2">STAFF</span>
        </div>
        <div class="filter-body-wrapper">
          <staffs-filter :storeFilter="storeFilter"></staffs-filter>
        </div>
      </v-container>
      <v-container fluid grid-list-lg class="pt-4">
        <staffs-list :storeFilter="storeFilter" :storePage="storePage"></staffs-list>
      </v-container>
      <create-staff></create-staff>
      <scroll-event></scroll-event>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import { staffsEventBus } from '@/components/admin/staffs/staffsEventBus';
  import StaffsFilter from '@/components/admin/staffs/StaffsFilter';
  import StaffsList from '@/components/admin/staffs/StaffsList';
  import CreateStaff from '@/components/admin/staffs/CreateStaff';
  import ScrollEvent from '@/components/customized-components/ScrollEvent';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        navigationDrawer: true,
      };
    },
    methods: {
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
      openDialog() {
        staffsEventBus.$emit('openDialog');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      StaffsFilter, StaffsList, CreateStaff, ScrollEvent,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Staffs.vue